import { Theme } from '@mui/material';

export const getGamesWrapperSx = (theme: Theme) => ({
  background: theme.palette.green_black,
  color: theme.palette.accent,
  textAlign: 'center',
  width: '33.33%',
});

export const getGameWrapperSx = (theme: Theme) => ({
  background: theme.palette.pale_accent,
  color: theme.palette.dark,
  py: 4,
});